<i18n
  src="@/locales/components/dashboard/agro_exporter/certifications_expired.yml"
  lang="yaml"
></i18n>
<template>
  <div class="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8">
    <div class="mb-4 flex items-center justify-between">
      <div>
        <h3 class="text-xl font-bold text-gray-900 mb-2">
          {{ $t("labels.title") }}
        </h3>
        <span class="text-base font-normal text-gray-500">
          {{ $t("labels.description") }}
        </span>
      </div>
      <div class="flex-shrink-0">
        <router-link
          class="text-sm font-medium text-lime-600 hover:text-lime-700 cursor-pointer hover:bg-gray-100 rounded-lg p-2"
          :to="{
            name: 'ae_certifications_providers_path',
            params: {
              agro_exporter_id: 10
            }
          }"
        >
          {{ $t("labels.show_link") }}
        </router-link>
      </div>
    </div>
    <div class="flex flex-col mt-8">
      <div class="overflow-x-auto rounded-lg">
        <div class="align-middle inline-block min-w-full">
          <div class="shadow overflow-hidden sm:rounded-lg">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th
                    scope="col"
                    class="px-2 py-4 text-left text-base font-medium text-gray-700"
                  >
                    {{ $t("labels.provider") }}
                  </th>
                  <th
                    scope="col"
                    class="px-2 py-4 text-left text-base font-medium text-gray-700"
                  >
                    {{ $t("labels.certification") }}
                  </th>
                  <th
                    scope="col"
                    class="px-2 py-4 text-left text-base font-medium text-gray-700"
                  >
                    {{ $t("labels.expiration_date") }}
                  </th>
                  <th
                    scope="col"
                    class="px-2 py-4 text-left text-base font-medium text-gray-700"
                  >
                    {{ $t("labels.status") }}
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white table-body">
                <tr
                  v-for="(certification, index) in certifications"
                  :key="index"
                  class="table-row"
                >
                  <td
                    class="p-3 whitespace-nowrap text-sm font-normal text-gray-900"
                  >
                    {{ certification.provider }}
                  </td>
                  <td
                    class="p-3 whitespace-nowrap text-sm font-normal text-gray-900"
                  >
                    {{ certification.certification }}
                  </td>
                  <td
                    class="p-3 whitespace-nowrap text-sm font-normal text-gray-500"
                  >
                    <span
                      :class="[
                        'font-semibold',
                        guiExpirationDate(certification.expiration_date)
                      ]"
                    >
                      {{ dateFormatter(certification.expiration_date) }}
                    </span>
                  </td>
                  <td
                    class="p-3 whitespace-nowrap text-sm font-normal text-gray-500"
                  >
                    <span
                      :class="[
                        'font-semibold',
                        guiExpirationDate(certification.expiration_date)
                      ]"
                    >
                      {{ status(certification.expiration_date) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/components/views/dashboard/requesters/agro_exporter/certifications";
export default {
  name: "DashboardAECertificationsExpired",
  data() {
    return {
      certifications: [],
      load_general_data: false
    };
  },
  props: {
    agro_exporter_id: { required: true }
  },
  created() {
    this.fetchFirstTenActiveCertifications();
  },
  methods: {
    async fetchFirstTenActiveCertifications() {
      const response = await Requester.fetchFirstTenActiveCertifications(
        this.agro_exporter_id
      );
      this.certifications = response.data;
      this.load_general_data = true;
    },
    status(expiration_date) {
      const diff_days = this.daysUntilExpirationDate(expiration_date);
      return diff_days >= 0
        ? `${diff_days} ${this.$t("labels.days")}`
        : this.$t("labels.expired");
    },
    guiExpirationDate(expiration_date) {
      const diff_days = this.daysUntilExpirationDate(expiration_date);

      if (diff_days < 0) {
        return "text-red-500";
      }
    }
  }
};
</script>
